<template lang="pug">
.permission-settings
  HScroll(:currentStep='currentStep')
    transition(name='simple-fade' mode='out-in')
      //- STEP 1 (action selector)
      ActionSelectorMenu(:items='actionItems' v-model='actionType')

    transition(name='simple-fade' mode='out-in')
      //- STEP 2 (visible if actionType is selected)
      div(v-if='actionType')
        template(v-if='actionType === "STAFF_LIST"')
          StaffList(
            @staffSelected='setSelectedStaff'
            :shouldRefresh='shouldRefreshStaffList'
            @finishLoading='shouldRefreshStaffList = false'
          )
        //- template(v-else-if='actionType === "GROUPS_AND_PERMISSIONS"')
        //-   GroupList(
        //-     @groupSelected='setSelectedGroup'
        //-   )
        template(v-else-if='actionType === "NEW_STAFF"')
          NewStaff(
            @submit='onNewStaffCreated'
          )
        template(v-else)
          GenericCard.actionDetail(size='45')
            .d-flex.flex-column.px-3.py-4
              .text-large {{ actionType }}

    transition(name='simple-fade' mode='out-in')
      //- STEP 3 (visible if item is selected)
      div(v-if='actionType === "STAFF_LIST" && selectedStaff')
        StaffEditor(
          :user='selectedStaff'
          @submit='onStaffInfoSaved'
        )
      //- div(v-else-if='actionType === "GROUPS_AND_PERMISSIONS" && selectedGroup')
      //-   GenericCard.actionDetail(size='75')
      //-     .sticky-top.bg-white
      //-       .d-flex.px-4.py-4.border-bottom
      //-         .text-large สิทธิ์การเข้าถึงเมนูการใช้งาน
      //-         .badge.ml-3(:class='selectedGroup.badgeStyle ? selectedGroup.badgeStyle:``')
      //-           .text-large
      //-             | {{ selectedGroup.name }}

      //-     template(v-for='group in permissionGroups')
      //-       .d-flex.px-4.py-3
      //-         .pr-4.flex-fill
      //-           .text-large {{ group.name }}
      //-         .d-flex.w-50.flex-wrap
      //-           template(v-for='i in group.items')
      //-             CustomCheckBox.w-50(:value='true')
      //-               | เมนูย่อย {{ i }}
      //-       hr.m-0

      //-     .sticky-bottom.bg-white
      //-       .d-flex.justify-content-center.px-4.py-3.border-top
      //-         button.btn.btn-secondary(@click='setCurrentStep(STEP_SELECT_ACTION)')
      //-           | ยกเลิก
      //-         button.btn.btn-upa-secondary.ml-3(@click='setCurrentStep(STEP_SELECT_ACTION)')
      //-           | บันทึก

  modal(
    name='status-dialog'
    width='360' height='400'
  )
    .d-flex.flex-column.h-100.align-items-center.justify-content-center
      img(src='@/assets/icons/success.svg')
      .text-large.mt-4
        | {{ statusMessage }}
      .pt-4
        button.btn.btn-secondary.mt-4(@click='hideStatusModal')
          | ตกลง

</template>

<script>
import StaffList from '@/components/_admin/permission-settings/panels/Staffs/StaffList.vue';
import StaffEditor from '@/components/_admin/permission-settings/panels/Staffs/StaffEditor.vue';
// import GroupList from '@/components/_admin/permission-settings/panels/Groups/GroupList.vue';
import NewStaff from '@/components/_admin/permission-settings/panels/NewStaff/NewStaff.vue';

export default {
  data: () => ({
    selectedStaff: null,
    selectedGroup: null,

    actionType: null,
    // actionDetail: null,
    receiptType: -1,
    deliveryType: -1,
    shipmentMethod: -1,
    currentStep: 0,

    filterProvince: '',

    STEP_INITIAL: 0,
    STEP_SELECT_ACTION: 1,
    STEP_SELECT_ITEM: 2,
    STEP_EDIT_ITEM: 3,

    actionItems: {
      STAFF_LIST: 'รายชื่อพนักงาน',
      // GROUPS_AND_PERMISSIONS: 'กลุ่มและสิทธิ์การใช้งาน',
      NEW_STAFF: 'เพิ่มพนักงาน',
    },

    statusMessage: '',

    // permissionGroups: [
    //   {
    //     name: 'เมนูทำรายการขาย',
    //     items: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    //   },
    //   {
    //     name: 'เมนูดูประวัติการขาย',
    //     items: [1, 2, 3, 4, 5, 6],
    //   },
    //   {
    //     name: 'เมนูดูค่าคอมเซลล์',
    //     items: [1, 2, 3, 4],
    //   },
    //   {
    //     name: 'เมนูหลักการใช้งาน xx',
    //     items: [1, 2, 3],
    //   },
    // ],

    shouldRefreshStaffList: false,
  }),
  watch: {
    actionType(newVal) {
      if (newVal) {
        this.setCurrentStep(this.STEP_SELECT_ACTION);
      }
    },
  },
  computed: {
    isActionDetailsValid() {
      return this.receiptType !== -1
          && this.deliveryType !== -1
          && this.shipmentMethod !== -1;
    },
  },
  methods: {
    setCurrentStep(step) {
      // change step to step - 1 => wait 50ms => change step to the actual value
      // so the change is always noticed by the HSrcoll component
      // HSroll will then scoll to the right, so the new view is visible to the user
      this.currentStep = step - 1;
      setTimeout(() => {
        this.currentStep = step;

        //
        // 1. PREPARE the data for each STEP
        // 2. RESET the data gathered from further steps
        //    so the data won't be mixed up
        //

        // STEP 1
        if (step < this.STEP_SELECT_ACTION) {
          this.actionType = null;
        }

        // STEP 2
        if (step < this.STEP_SELECT_ITEM) {
          this.selectedStaff = null;
          this.selectedGroup = null;
        }
      }, 50);
    },
    setSelectedStaff(e) {
      this.selectedStaff = e;
      this.setCurrentStep(this.STEP_SELECT_ITEM);
    },

    // group
    setSelectedGroup(e) {
      this.selectedGroup = e;
      this.setCurrentStep(this.STEP_SELECT_ITEM);
    },

    hideStatusModal() {
      this.$modal.hide('status-dialog');
    },

    // New Staff
    onNewStaffCreated(e) {
      console.log(e);
      this.statusMessage = 'คุณเพิ่มพนักงานใหม่สำเร็จแล้ว';
      this.$modal.show('status-dialog');
      this.setCurrentStep(this.STEP_INITIAL);
    },

    onStaffInfoSaved(e) {
      console.log(e);
      this.statusMessage = 'บันทึกข้อมูลพนักงานเรียบร้อย';
      this.$modal.show('status-dialog');
      this.setCurrentStep(this.STEP_SELECT_ACTION);

      this.shouldRefreshStaffList = true;
    },
  },
  components: {
    StaffList,
    StaffEditor,
    // GroupList,
    NewStaff,
  },
};
</script>

<style lang="scss">
.permission-settings {
  > .h-scroll {
    height: 100%;
  }
}
</style>
